import React from 'react';
import PropTypes from 'prop-types';
import Events from 'APP_ROOT/components/common/events';
import Coaching from './Coaching';
import Protected from 'APP_ROOT/components/common/protected';

/**
 * A simple wrapper to check if user has permission to view coaching pages
 * */
export default class CoachingContainer extends React.Component {

    static propTypes = {
        ravens: PropTypes.array,
        user: PropTypes.object,
        getUserData: PropTypes.func.isRequired,
        features: PropTypes.shape({
            fleet_reports: PropTypes.bool
        })
    };

    constructor (props) {    
        super(props);

        this.state = {
            userDataLoaded: false
        }
    }

    componentDidMount () {
        if (!this.props.ravens) {
            this.props.getUserData(this.onUserDataLoaded);
        } else {
            this.onUserDataLoaded();
        }
    }

    onUserDataLoaded = () => {
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.setState({
            userDataLoaded: true
        });
    }

    render () {
        if (!this.state.userDataLoaded || !this.props.ravens ) {
            return null;
        }

        const { features } = this.props;

        if (!features) {
            console.error("Reports index render with invalid features prop.");
            return null;
        }

        if (!features.hasOwnProperty("fleet_reports")) {
            console.warn("Reports index render with incomplete features, fleet_reports not defined (race condition?)");
            return null;
        }

        return (
            <Protected resource="coaching" action="read" gate={features.fleet_reports} showNotFound>
                <Coaching {...this.props} />
            </Protected>
        );
    }
}